import React, { useRef, useState } from 'react';
import { Space, Spin } from 'antd';

import Table from '@components/Table';
import { SearchInput } from '@components/Page';
import { useAppContext } from '@components/AppContext';
import { type AppContext } from '@components/AppContext/types';
import { indexOrganizationsOperation as indexOperation } from '@api/services/organizations';

import useOrganizations from './helpers/useOrganizations';
import useColumnsConfig from './helpers/useColumnsConfig';

type Props = {
  onAfterSwitch?: () => Promise<void> | void;
};

type TableRef = {
  search: (value: string) => void;
};

const OrganizationsList = ({ onAfterSwitch: onAfterSwitchCustom }: Props) => {
  const table = useRef<TableRef>({
    search: () => undefined,
  });

  const [isLoading, setIsLoading] = useState(false);

  const items = useOrganizations();
  const { authorizeOrganizationIdentity } = useAppContext() as AppContext;

  const onBeforeSwitch = async () => setIsLoading(true);
  const onAfterSwitch = onAfterSwitchCustom || (() => undefined);

  const columnsConfig = useColumnsConfig({ onBeforeSwitch, onAfterSwitch });

  const pagination = {
    pageSize: 10,
    showSizeChanger: false,
  };

  const tableProps = {
    indexItems: () => authorizeOrganizationIdentity(),
    size: 'small',
    items,
    table,
    pagination,
    columnsConfig,
    indexOperation,
  };

  const onSearch = (value: string) => table.current.search(value);

  return (
    <Spin spinning={isLoading}>
      <Space
        style={{ width: '100%' }}
        direction="vertical"
      >
        <SearchInput onSearch={onSearch} />

        <Table {...tableProps} />
      </Space>
    </Spin>
  );
};

export default OrganizationsList;
